'use client';
import FormInput from '../FormInput';
import FormCheckbox from '../FormCheckbox';

export default function FormInputAndCheckbox({ id, data, index, callback }: any) {
    const handleCallback = (n: number, item: any, idx, v) => {
        const newObj = JSON.parse(JSON.stringify(data));
        newObj.data[n].itemVal = v;
        callback(newObj, idx, v);
    };

    return (
        <div className="form-input-and-checkbox">
            <FormInput id={id} data={data.data[0]} callback={(item, idx, v) => handleCallback(0, item, idx, v)} index={index} />
            <FormCheckbox id={id} data={data.data[1]} callback={(item, idx, v) => handleCallback(1, item, idx, v)} index={index} />
        </div>
    );
}
